const newsSchemaMapper = (restSchema) => ({
  entityBundle: "news",
  publishedAt: +restSchema.published_at * 1000,
  publishedAtRawField: {
    first: {
      value: +restSchema.published_at * 1000,
      publishedAtOrNow: restSchema.published_at,
    },
  },
  label: restSchema.title,
  id: restSchema.nid,
  title: restSchema.title,
  created: restSchema.created,
  path: {
    alias: restSchema.url,
  },
  url: {
    path: restSchema.url,
  },
  fieldTags:
    restSchema.tags_name !== null
      ? restSchema.tags_name.map((name) => ({ name }))
      : [],
  fieldExternalLink: restSchema.external_link && {
    uri: {
      path: restSchema.external_link,
    },
  },
  fieldText: restSchema.text,
  fieldSponsored: restSchema.sponsored,
  fieldImage: {
    fieldCredits: restSchema.image_credits,
    fieldMediaImage: {
      alt: restSchema.image_alt,
      title: restSchema.image_title,
      entity: {
        filemime: restSchema.image_filemime,
        uri: restSchema.image_uri,
      },
      style: {
        url: restSchema.image_url,
        width: restSchema.image_width,
        height: restSchema.image_height,
      },
    },
  },
});

export default newsSchemaMapper;
